import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import styles from './Navbar.module.css';

const NAV_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/marketplace', label: 'Marketplace' },
  { to: '/sanctuary', label: 'Urban Sanctuary' },
  { to: '/community', label: 'Community' },
  { to: '/pricing', label: 'Pricing' },
  { to: '/blog', label: 'Blog' },
  { to: '/about', label: 'About' },
];

export function Navbar() {
  const { user, logout } = useAuth();

  return (
    <header className={styles.header}>
      <nav className={`container ${styles.nav}`}>
        <Link to="/" className={styles.logo}>
          <span className={styles.logoIcon}>🌿</span>
          <span className={styles.logoText}>UrbanLife<span>.Works</span></span>
        </Link>

        <ul className={styles.links}>
          {NAV_LINKS.map(({ to, label }) => (
            <li key={to}>
              <NavLink
                to={to}
                className={({ isActive }) => `${styles.link} ${isActive ? styles.active : ''}`}
                end={to === '/'}
              >
                {label}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className={styles.actions}>
          {user ? (
            <>
              <Link to="/dashboard" className={`btn btn-outline ${styles.btnSm}`}>
                {user.full_name?.split(' ')[0] ?? 'Dashboard'}
              </Link>
              <button onClick={logout} className={`btn btn-outline ${styles.btnSm}`}>
                Sign out
              </button>
            </>
          ) : (
            <>
              <Link to="/auth/login" className={`btn btn-outline ${styles.btnSm}`}>Login</Link>
              <Link to="/auth/register" className={`btn btn-primary ${styles.btnSm}`}>
                Get Started →
              </Link>
            </>
          )}
        </div>
      </nav>
    </header>
  );
}
